module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Text-ef93f28c6c3166d90686b3b9a2fb14f0.svg";